
import * as React from "react";

interface IHighlightLabelProps {
    label: string
    icon: string

}

interface IHighlightLabelState {
}

export default class HighlightLabel extends React.Component<IHighlightLabelProps, IHighlightLabelState>{

    constructor(props:IHighlightLabelProps){
        super(props);
    }


    render() {

        return (
            <div className="highlight-label">
                <div className = "content">
                    <div className="icon_container">
                        <img src={this.props.icon} alt=""/>
                    </div>
                    <div className="label">
                        {this.props.label}
                    </div>
                </div>
            </div>
        );
    }
}
